export default "assets/images/store-locator-marker-9962cfe1.svg";